const imageUrls = {
  loader: 'images/loader.gif',
};

export default imageUrls;
